export default __webpack_public_path__ + "static/media/CompletedImage.d828fab6.svg";